import { zodResolver } from '@hookform/resolvers/zod';
import { AxiosProgressEvent } from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { ToastService } from '@shared/ui';

import { useHeaderSheetOpenStore } from '@shared/store';

//TODO : Refactor api.ts
import { sendTicketAttachment } from '@/api/support/services';

import { CreateTicketValidation } from '../schema';
import { useTicketListRefresh } from '../store';
import { TFileItem } from '../type';
import { useAddTicket } from '../../api';
import { ErrorResponse } from '@shared/api';

export const useCreateTicket = (onTicketCreated?: () => void, onClose?: () => void) => {
  const form = useForm<z.infer<typeof CreateTicketValidation>>({
    resolver: zodResolver(CreateTicketValidation),
    defaultValues: {
      subject: '',
      description: '',
    },
  });
  const [fileList, setFileList] = useState<TFileItem[]>([]);
  const [attachmentIds, setAttachmentIds] = useState<string[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  const scrollBottomRef = useRef<HTMLDivElement | null>(null);

  const setTicketListRefresh = useTicketListRefresh((state) => state.setter);
  const setIsSheetOpen = useHeaderSheetOpenStore((state) => state.setter);
  const IsSheetOpen = useHeaderSheetOpenStore((state) => state.data);
  useEffect(() => {
    const t = setTimeout(() => {
      scrollBottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
    return () => clearTimeout(t);
  }, [fileList.length]);
  const createTicket = useAddTicket();
  const resetForm = () => {
    form.reset();
    setFileList([]);
    setAttachmentIds([]);
  };

  const handleFileChange = (files: TFileItem[]) => {
    setFileList(files);

    const ids = files
      .filter((f) => f.status === 'done' && typeof f.response === 'string')
      .map((f) => f.response as string);

    setAttachmentIds(ids);
  };

  const uploadFn = async (file: File, onProgress?: (p: AxiosProgressEvent) => void) => {
    try {
      setIsUploading(true);
      return await sendTicketAttachment(file, onProgress);
    } finally {
      setIsUploading(false);
    }
  };

  const onSubmit = (values: z.infer<typeof CreateTicketValidation>) => {
    if (isUploading) {
      ToastService.info('لطفا تا پایان بارگذاری فایل صبر کنید.');
      return;
    }
    createTicket.mutate(
      {
        description: values.description.trim(),
        ...(values.subject && { subject: values.subject.trim() }),
        attachmentIds: attachmentIds ?? [],
      },
      {
        onError: (error: ErrorResponse) => {
          ToastService.error(error.formatMessage());
        },

        onSuccess: () => {
          ToastService.success('تیکت با موفقیت ثبت شد');

          resetForm();
          setTicketListRefresh(true);
          onTicketCreated?.();
          onClose?.();
          if (IsSheetOpen) setIsSheetOpen(false);
        },
      }
    );
  };

  return {
    form,
    onSubmit,
    scrollBottomRef,
    fileList,
    attachmentIds,
    isUploading,
    isLoading: createTicket.isPending,
    handleFileChange,
    uploadFn,
    resetForm,
  };
};
